module.exports = __webpack_public_path__ + "static/media/IAB_logo.c4b833a9.png";